import axios from 'axios'
import config from '@/config.js'

const API_URL = config.apiUrl

const state = {
  location: null,
  locations: [],
  allGeoLocations: []
}

const mutations = {
  setLocation(state, location){
    state.location = location
  },
  setLocations(state, locations){
    state.locations = locations
  },
  setGeoLocations(state, locations) {
    state.allGeoLocations = locations
  },
  setCategoryLocations(state, locations) {
    state.categoryLocations = locations
  },
  setLemmaLocations(state, locations) {
    state.lemmaLocations = locations
  },
  setGroupData(state, locations) {
    state.dataTimeLocations = locations
  },
  setCategoryBins(state, bins) {
    state.dataBins = bins
  },
  setTypeBins(state, bins) {
    state.dataBins = bins
  },
  setLemmaBins(state, bins) {
    state.dataBins = bins
  },
  setParameterBins(state, bins) {
    state.dataBins = bins
  }
}

const getters = {
}

const actions = {
  loadLocation({ commit }, locationId){
    axios
      .get(`${API_URL}/location/${locationId}`)
      .then(r => r.data)
      .then(location => {
        commit('setLocation', location)
      })
  },
  searchLocations({ commit }, options){
    let query = options.query
    let exclude = (options.exclude || []).join(',')
    axios
      .get(`${API_URL}/locations/autocomplete?query=${query}&exclude=${exclude}`)
      .then(r => r.data)
      .then(locations => {
        commit('setLocations', locations)
      })
  },
  loadNAAFLocations({ commit }, naafId){
    return new Promise((resolve) => {
      axios
        .get(`${API_URL}/locations/naaf_geolocations/${naafId}`)
        .then(r => r.data)
        .then(locations => {
          commit('setGeoLocations', locations)
          resolve()
        })
    })
  },
  loadGroupData({ commit }, groupObj){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/locations/group_data`, groupObj)
        .then(r => r.data)
        .then(locations => {
          commit('setGroupData', locations.results)
          resolve()
        })
    })
  },
  loadLemmaBins({ commit }, lemmagroupId){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/locations/lemmaBins`, {lemmagroup: lemmagroupId})
        .then(r => r.data)
        .then(locations => {
          commit('setLemmaBins', locations.results)
          resolve()
        })
    })
  },
  loadParameterBins({ commit }, parameterId){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/locations/parameterBins`, {parameter: parameterId})
        .then(r => r.data)
        .then(locations => {
          commit('setParameterBins', locations.results)
          resolve()
        })
    })
  },
  loadCategoryBins({ commit }, categorygroupId){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/locations/categoryBins`, {categorygroup: categorygroupId})
        .then(r => r.data)
        .then(locations => {
          commit('setCategoryBins', locations.results)
          resolve()
        })
    })
  },
  loadTypeBins({ commit }, typegroupId){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/locations/typeBins`, {typegroup: typegroupId})
        .then(r => r.data)
        .then(locations => {
          commit('setTypeBins', locations.results)
          resolve()
        })
    })
  },
  allGeoLocations({ commit }){
    return new Promise((resolve) => {
      axios
        .get(`${API_URL}/locations/all_geolocations`)
        .then(r => r.data)
        .then(locations => {
          commit('setGeoLocations', locations)
          resolve()
        })
    })
  },
  saveLocation(_, location){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/location/${location.id}`, location)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  createLocation(_, location){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/location`, location)
        .then(response => {
          this.dispatch('addNotification', {
            type: 'success',
            text: `Location created`
          })
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  deleteLocation(_, location){
    return new Promise((resolve) => {
      axios
        .delete(`${API_URL}/location/${location.id}`)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  mergeLocations(_, { mainLocationId, locationIds }){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/locations/merge`, { mainLocationId, locationIds })
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}

